module.exports = __webpack_public_path__ + "img/johnoliver3.eadafef1.jpg";